<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane label="视频配置" name="first" clor="red"></el-tab-pane>
						<el-tab-pane label="视频区域" name="second"></el-tab-pane>
						<el-tab-pane label="视频播放" name="third"></el-tab-pane>
						<!--<el-tab-pane label="视频流播放" name="fourth"></el-tab-pane>-->
					</el-tabs>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<div style="height: calc(100% - 84px);">
			<VideoTable ref="videoTable" v-if="activeName=='first'"/>
			<VideoRegion ref="videoRegion" v-if="activeName=='second'"/>
			<VideoPlay ref="videoPlay" v-if="activeName=='third'"/>
			<!--<VideoPlayTest ref="videoPlayTest" v-if="activeName=='fourth'"/>-->
		</div>
	</div>
</template>

<script>
	import VideoTable from '@/components_pages/Video/VideoTable';
	import VideoRegion from '@/components_pages/Video/VideoRegion';
	import VideoPlay from "@/components_pages/Video/VideoPlay";
//	import VideoPlayTest from "@/components_pages/Video/VideoPlayTest";

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date
		 */
		name: "VideoSet",
		/**
		 * @Des 组件 注册
		 * @Auth
		 * @Date
		 */
		components: {
			// 视频列表组件
			VideoTable,
			// 视频区域组件
			VideoRegion,
			// 组件 视频播放
			VideoPlay,
			// 组件 视频播放 test
//          VideoPlayTest,
		},
		/**
		 * @Des 数据 注册
		 * @Auth
		 * @Date
		 */
		data() {
			return {
				activeName: 'first'
			}// return
		},// data
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date
		 */
		mounted(){
			
		},// mounted
		/**
		 * @Des 方法 注册
		 * @Auth
		 * @Date
		 */
		methods: {
			/**
			 * @Des 关闭路由
			 * @Auth
			 * @Date
			 */
			closeRouter () {
				// 跳转到 首页
				this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
			},// closeRouter
			
			/**
			 * @Des tab 切换
			 * @Auth
			 * @Date
			 */
			handleClick(tab, event) {
				if (tab.index == 0) {
					//请求1
				} else if (tab.index == 1) {
					//请求2
				}
			},// handleClick
			
		},// methods
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/video/VideoSet.vue